export enum InputStatus {
  VALID = 'VALID',
  INVALID = 'INVALID'
}
